import React from "react";
import GitHubCalendar from "react-github-calendar";

const ACCENT = {
  light: "#3b82f6", // Blue accent for light mode
  dark: "#60a5fa"   // Lighter blue accent for dark mode
};
const BG = {
  light: "rgba(220, 230, 255, 0.7)", // Light mode glass background (from style.css .glass-card)
  dark: "rgba(30, 34, 54, 0.7)"    // Dark mode glass background (from style.css .glass-card)
};

// CONTRIBUTION_LEVEL_COLORS and calendarTheme are removed to rely on CSS overrides in style.css

function GithubDaysCard({ username = "Meetjain1", currentTheme = "light" }) {
  const githubLink = `https://github.com/${username}`;
  // Responsive block size and font size
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;
  const blockSize = isMobile ? 12 : 22;
  const blockMargin = isMobile ? 2 : 5;
  const fontSize = isMobile ? 12 : 18;
  const calendarContainerStyle = isMobile
    ? { overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }
    : {};

  // renderBlock no longer sets fill color; CSS in style.css will handle it.
  const blockRender = (block, activity) => {
    // const level = block.props["data-level"] || 0; // Level no longer needed here
    // const fill = colorSet[level] || colorSet[0]; // Fill is removed
    return React.cloneElement(block, {
      style: {
        // fill is now controlled by style.css
        stroke: currentTheme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
        strokeWidth: 0.5,
        rx: 3,
        ry: 3
      }
    });
  };

  return (
    <div
      className="stat-card"
      style={{
        background: BG[currentTheme],
        color: currentTheme === "dark" ? "#fff" : "#222",
        maxWidth: "1100px",
        minHeight: 260,
        margin: "20px auto",
        padding: isMobile ? "10px 2px" : "20px"
      }}
    >
      <div style={{ width: "100%" }}>
        {/* Header */}
        <div
          style={{
            fontWeight: 700,
            fontSize: isMobile ? 18 : 28,
            marginBottom: 10,
            color: ACCENT[currentTheme],
            textAlign: "center"
          }}
        >
          Days I <span style={{ color: ACCENT[currentTheme] }}>Code</span>
        </div>
        {/* Username Link */}
        <div style={{ textAlign: "center", marginBottom: 15 }}>
          <a
            href={githubLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: ACCENT[currentTheme],
              fontWeight: 600,
              fontSize: isMobile ? 14 : 20,
              textDecoration: "underline"
            }}
          >
            @{username}
          </a>
        </div>
        {/* GitHub Calendar */}
        <div style={calendarContainerStyle}>
          <GitHubCalendar
            username={username}
            blockSize={blockSize}
            blockMargin={blockMargin}
            fontSize={fontSize}
            colorScheme={currentTheme}
            renderBlock={blockRender}
            className="react-github-calendar"
            style={{ margin: "0 auto", minWidth: isMobile ? 400 : undefined }}
            showTotalCount={true}
            labels={{ totalCount: "contributions in the last year" }}
          />
        </div>
      </div>
    </div>
  );
}

export default GithubDaysCard;
